// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__PPS4_","title":"styles_title__bnmgy"};